<template>

    <div class="modal fade show d-block ps--scrolling-y" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('default.select_linkedin_account')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="!selectAccountModalReady" class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
              <loading slot="waiting"/> </div>
            <div v-else>

            <v-wait for="account-list">
              <loading slot="waiting"/>
              <p>{{ $t('default.select_linkedin_account_desc')}} <strong>{{ accounts.account.name }}</strong>:</p>
              <v-wait for="choose-account">
                <loading slot="waiting"/>
              <b-row class="overflow-hidden">
                <template v-for="account in accounts.data">
                  <b-col md="6" sm="12" @click="choose_account(accounts.account.id, account, accounts.integration)">
                    <b-card class="overflow-hidden mb-4 instagram-select-account-card">
                      <b-row>
                        <b-col md="4" class="instagram-select-account-image">
                          <b-card-img :src="account.logo" width="180" alt="Image" style="border-radius:50%;border: #cccccc solid 1px;"></b-card-img>
                        </b-col>
                        <b-col md="8" class="instagram-select-account-card-body">
                          <h4 class="instagram-select-account-card-title">
                            <span>{{ account.name }}</span>
                          </h4>
                          <p><strong>{{ $t('default.desc')}}</strong> : {{ account.description ? account.description : '-' }}</p>
                          <p><strong>{{ $t('default.website')}}</strong> : {{ account.website ? account.website : '-' }}</p>
                          <p><strong>{{ $t('customer.followers')}}</strong> : {{ account.followers }}</p>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                </template>

              </b-row>
              </v-wait>
            </v-wait>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

    export default {

        mounted: function () {
            // console.log('LinkedIn Select Account Modal mounted');
            requestAnimationFrame(() => {
                this.fetchAccountList({
                    id: this.id,
                    integration: this.integration
                }).catch(() => {
                    this.$close(false);
                });
                this.updateSelectAccountModalReady(true);
            });
        },

        created: function () {
            // console.log('LinkedIn Select Account Modal created');
        },
        
        destroyed() {
            // console.log('LinkedIn Select Account Modal destroyed.');
        },

        data: function() {
             return  {
                 accounts_api: '/api/v1/settings/accounts/selection/',
            }
        },

        computed: {
          ...mapGetters({
            accounts: 'Accounts/getLinkedInAccountList',
            selectAccountModalReady: 'Accounts/getSelectAccountModalReady',
          }),
        },

        methods: {
          ...mapActions('Accounts', [
            'fetchAccountList',
            'chooseAccount',
            'updateSelectAccountModalReady',
          ]),

          choose_account: function(id, account_data, integration){
            const modal = this;
            this.chooseAccount({id, account_data, integration}).then(function () {
              modal.$close(true);
            }).catch(function (){
              modal.$close(false);
            });
          },
        },
    }
</script>


